import StoreAiCallContractWorkflowLoad from "./store-ai-call-contract-workflow-load";
import StoreAiCallContractWorkflowCommon from "./store-ai-call-contract-workflow-common";
import commentLoad from './ai-call-contract-comment-load'
import commentPost from './ai-call-contract-comment-post'

export default () => {
    window.reloadMasterInfo = () => {
        let token = ''
        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
        })
        StoreAiCallContractWorkflowLoad(token)
    }

    window.enablePlanEndDate = () => {
        Array.from(document.getElementsByClassName('end_date')).forEach(el => {
            if(el.value === '') {
                el.readOnly = false
            }
        })
    }

    window.enableOptionEndDate = () => {
        const el = event.target
        el.parentNode.parentNode.parentNode.getElementsByClassName('end_date')[0].readOnly = false
    }

    window.viewPastData = () => {
        Array.from(document.getElementsByClassName('end_date')).forEach(el => {
            el.parentNode.parentNode.parentNode.style.display = ''
        })
    }

    document.addEventListener('DOMContentLoaded', () => {
        StoreAiCallContractWorkflowCommon()
        reloadMasterInfo()

        const store_ai_call_contract_workflow_id = document.getElementById('store_ai_call_contract_workflow_for_edit_store_ai_call_contract_workflow_id').value
        const store_ai_call_contract_id = document.getElementById('store_ai_call_contract_workflow_for_edit_store_ai_call_contract_id').value

        Array.from(document.getElementsByClassName('is-invalid')).forEach(elm => {
            if (elm.classList.contains('end_date')) {
                // 終了日を編集可にする
                elm.readOnly = false
            }
        })

        let token = ''
        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
        })

        commentLoad(store_ai_call_contract_id, store_ai_call_contract_workflow_id, token, 30)
        commentPost(store_ai_call_contract_id, store_ai_call_contract_workflow_id, token)
        Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
            el.addEventListener('click', (e) => {
                commentLoad(store_ai_call_contract_id, store_ai_call_contract_workflow_id, token, 30)
            })
        })

        // 過去日を非表示
        const today = new Date().toLocaleDateString(
            "ja-JP", {year: "numeric", month: "2-digit", day: "2-digit"}
        ).replaceAll('/', '-')
        Array.from(document.getElementsByClassName('end_date')).forEach(el => {
            if(el.value === '' || el.value >= today) {
            } else {
                el.parentNode.parentNode.parentNode.style.display = 'none'
            }
        })
    })
}
